<app-cover-static-exam />
<app-why-love-exam />
<app-static-card-exam />
<!-- <section>
  <h1 class="mb-10 text-[#010128] font-bold text-2xl text-center xl:text-6xl md:text-4xl lg:text-5xl">Browse Flashcards by subjects</h1>
  <app-browse-subjects />
</section> -->
<app-explore-tools />
